// For mobile
// #search-drawer predictive-search .search__predictive__main input 

// For desktop
// #search-popdown predictive-search .search__predictive__main input
// console.log("Wizzy custom js");
function syncAutocompleteWidth() {
    const searchBar = document.querySelector("#search-popdown predictive-search .search__predictive__actions");
    const autoComplete = document.querySelector(".wizzy-autocomplete-wrapper");
    if (searchBar && autoComplete) {
        const width = searchBar.offsetWidth + "px";
        autoComplete.style.setProperty("width", width);
    }
}
document.body.addEventListener("click", function(event) {
    event.target.matches("#search-popdown predictive-search .search__predictive__actions") && setTimeout(syncAutocompleteWidth, 100)
}),
window.addEventListener("load", syncAutocompleteWidth),
window.addEventListener("resize", syncAutocompleteWidth),
function updateFilterPosition() {
  let filterWrapper = document.querySelector(
    ".has-facets-in-drawer .wizzy-search-filters-left-wrapper"
  );
  let navBar = document.querySelector(
    ".wizzy-search-wrapper.has-left-facets .wizzy-search-results-wrapper .wizzy-search-results-container"
  );

  if (filterWrapper && navBar) {
    let leftPosition = navBar.getBoundingClientRect().left - 10;
    let topPosition = navBar.getBoundingClientRect().bottom;
    // console.log("Left Position", leftPosition);

    // filterWrapper.style.setProperty(
    //   "margin-left",
    //   `${leftPosition}px`,
    //   "important"
    // );
    // console.log("Inside update filters");

    // console.log("filter position", filterWrapper.style.left);
  }
}

// function updateFilterPosition() {
//   let filterWrapper = document.querySelector(
//     ".has-facets-in-drawer .wizzy-search-filters-left-wrapper"
//   );
//   let navBar = document.querySelector(
//     ".wizzy-search-wrapper.has-left-facets .wizzy-search-results-wrapper .wizzy-search-results-container"
//   );

//   if (filterWrapper && navBar) {
//     let leftPosition = navBar.getBoundingClientRect().left - 10;
//     let topPosition = navBar.getBoundingClientRect().bottom;

//     console.log("Left Position", leftPosition);

//     // Ensure filter is visible before animation
//     filterWrapper.style.display = "block";

//     setTimeout(() => {
//       filterWrapper.style.setProperty(
//         "margin-left",
//         `${leftPosition}px`,
//         "important"
//       ); // Dynamically set left position
//       filterWrapper.classList.add("show"); // Add class for animation
//     }, 5); // Small delay for smooth transition
//   }
// }
function OpenFilters()
{
  let searchWrapper = document.querySelector(
    ".wizzy-search-wrapper.has-left-facets .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-results "
  );
  let filterWrapper = document.querySelector(
    ".has-facets-in-drawer .wizzy-search-filters-left-wrapper"
  );
  let navBar = document.querySelector(".wizzy-search-results");
  if(searchWrapper)
    searchWrapper.classList.add("filter-opened");
  if(filterWrapper)
    filterWrapper.classList.add("opened");
  // const rect = navBar.getBoundingClientRect();

  // if (filterWrapper) {
  //   filterWrapper.style.setProperty(
  //     "display",
  //     "block",
  //     "important"
  //   );
  //   // filterWrapper.style.top = `${rect.bottom}px`;
  //   // console.log("Inside toggle 1", rect.bottom);
  //   filterWrapper.style.setProperty("left", "0", "important");
  // }

  // if (filterWrapper) {
  //   updateFilterPosition();
  // }
  // if (searchWrapper)
  //   searchWrapper.style.setProperty("padding-left", "280px");
  let textFilter = document.querySelector(
    ".wizzy-filters-desktop-entry"
  );
  if (textFilter) textFilter.innerText = "Hide Filters";
  // updateFilterPosition();
  
  // console.log("Set 1 in Open filters");
}
function CloseFilters()
{
  // console.log("inside close filters");
  let filterWrapper = document.querySelector(
    ".has-facets-in-drawer .wizzy-search-filters-left-wrapper"
  );
  // if (filterWrapper)
  //   filterWrapper.style.setProperty("display", "none", "important");
  let searchWrapper = document.querySelector(
    ".wizzy-search-wrapper.has-left-facets .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-results "
  );
  // if (filterWrapper.classList.contains("show")) {
  //   // Hide filter with animation
  //   filterWrapper.classList.remove("show");
  // }
  // console.log("inside close filters 1");
  if(searchWrapper)
    searchWrapper.classList.remove("filter-opened");
  if(filterWrapper)
    filterWrapper.classList.remove("opened");
  // if (searchWrapper)
  //   searchWrapper.style.setProperty("padding-left", "0px");
  let textFilter = document.querySelector(
    ".wizzy-filters-desktop-entry"
  );
  if (textFilter) textFilter.innerText = "Filters";
  // localStorage.setItem("filter_opened", 0);
  // console.log("inside close filters 2");
}
function changeCurrency() {
  setTimeout(() => {
    if (
      window.bucksCC &&
      window.bucksCC.reConvert &&
      typeof window.bucksCC.reConvert === "function"
    ) {
      window.bucksCC.reConvert();
    }
  },100);
}
function rgbToHex(rgb) {
  let match = rgb.match(/\d+/g); // Extract numbers
  if (!match) return rgb; // If no match, return original

  let r = parseInt(match[0]).toString(16).padStart(2, "0");
  let g = parseInt(match[1]).toString(16).padStart(2, "0");
  let b = parseInt(match[2]).toString(16).padStart(2, "0");

  return `#${r}${g}${b}`;
}

// const colorMap = new Map([
//   ["White", ["#ffffff", !1]],
//   ["Aqua", ["#00ffff", !1]],
//   ["Arcade", ["#0a0527", !1]],
//   ["Beige", ["#f5f5dc", !1]],
//   ["Beige and Black", ["#f5f5dc", !1]],
//   ["Black and Blue", ["#0000ff", !1]],
//   ["Black and Gold", ["#ffd700", !1]],
//   ["Black and Grey", ["#808080", !1]],
//   ["Black and Red", ["#7c0000", !1]],
//   ["Black and White", ["#808080", !1]],
//   ["Blue", ["#1d5caa", !1]],
//   ["Blue and Gold", ["#002DB0", !1]],
//   ["Brown", ["#804020", !1]],
//   ["Copper", ["#B87333", !1]],
//   ["Gold", ["#D4Af37", !1]],
//   ["Gold and Green", ["#ffd700", !1]],
//   ["Gold and Pink", ["#ffc87c", !1]],
//   ["Gold and Red", ["#e9967a", !1]],
//   ["Gold and Yelllow", ["#ffdf00", !1]],
//   ["Indigo", ["#4b0082", !1]],
//   ["Ivory", ["#f5ecda", !1]],

//   ["Red", ["#ff0000", !1]],
//   ["Green", ["#008000", !1]],
//   ["Grey", ["#808080", !1]],
//   ["Black", ["#000000", !1]],
//   ["Pink", ["#ffc0cb", !1]],
//   ["MUSTARD", ["#808080", !1]],
//   ["SKY BLUE", ["#66ccff", !1]],
//   ["Purple", ["#800080", !1]],
//   ["Orange", ["#ffa500", !1]],
//   ["Yellow", ["#ffff00", !1]],
//   ["SAND", ["#C2B280", !1]],
//   ["Wine", ["#722F37", !1]],
//   ["MAROON", ["#800000", !1]],
//   ["Peach", ["#ffe5b4", !1]],
//   ["LAVENDER", ["#e6e6fa", !1]],
//   ["Beige", ["#f5f5dc", !1]],
//   ["MOUSE", ["#635f57", !1]],
//   ["NAVY BLUE", ["#000080", !1]],
//   ["cream", ["#ccdee5", !1]]
// ]);

const colorMap = new Map([
  ["Multi-coloured", ["https://i.ibb.co/BVjj74X/classic-color-spectrum-rgb-line-gradient-vector-522680-173-copy.png", !0]],
  ["Abstract Floral Print", ["#e5e5e5", !1]],
  ["Acai Purple", ["#6f42c1", !1]],
  ["Aqua", ["#00ffff", !1]],
  ["Aqua Mint", ["#7fffd4", !1]],
  ["Arcade", ["#0a0527", !1]],
  ["Aster Blue", ["#4666ff", !1]],
  ["Azalea Pink", ["#f7a1c4", !1]],
  ["B/W Checks", ["#000000", !1]],
  ["B/W Motif Print", ["#000000", !1]],
  ["Beige", ["#f5f5dc", !1]],
  ["Beige and Black", ["#f5f5dc", !1]],
  ["Berry Purple", ["#800080", !1]],
  ["Black", ["#000000", !1]],
  ["Black & White", ["#000000", !1]],
  ["Black and Blue", ["#0000ff", !1]],
  ["Black and Gold", ["#ffd700", !1]],
  ["Black and Grey", ["#808080", !1]],
  ["Black and Multi-coloured", ["#000000", !1]],
  ["Black and Red", ["#7c0000", !1]],
  ["Black and White", ["#808080", !1]],
  ["Blue", ["#1d5caa", !1]],
  ["Blue and Gold", ["#002db0", !1]],
  ["Brown", ["#804020", !1]],
  ["Charcoal", ["#36454f", !1]],
  ["Copper", ["#b87333", !1]],
  ["Denim", ["#1560bd", !1]],
  ["Emerald Green", ["#50c878", !1]],
  ["French Blue", ["#0072bb", !1]],
  ["Gold", ["#d4af37", !1]],
  ["Gold And Green", ["#ffd700", !1]],
  ["Gold And Pink", ["#ffc87c", !1]],
  ["Gold And Red", ["#e9967a", !1]],
  ["Gold And Yellow", ["#ffdf00", !1]],
  ["Green", ["#008000", !1]],
  ["Grey", ["#808080", !1]],
  ["Ice Blue", ["#99ffff", !1]],
  ["Indigo", ["#4b0082", !1]],
  ["Ivory", ["#f5ecda", !1]],
  ["Jade Green", ["#00a86b", !1]],
  ["Lavender", ["#e6e6fa", !1]],
  ["Light Pink", ["#ffb6c1", !1]],
  ["Mustard Yellow", ["#ffdb58", !1]],
  ["Navy Blue", ["#000080", !1]],
  ["Off-White", ["#faf9f6", !1]],
  ["Olive Green", ["#808000", !1]],
  ["Orange", ["#e5990e", !1]],
  ["Peach", ["#ffe5b4", !1]],
  ["Pink", ["#e79fab", !1]],
  ["Purple", ["#800080", !1]],
  ["Red", ["#d13b38", !1]],
  ["Rust Orange", ["#c45508", !1]],
  ["Seashell", ["#fff5ee", !1]],
  ["Silver", ["#c0c0c0", !1]],
  ["Sky Blue", ["#87ceeb", !1]],
  ["Teal Blue", ["#008080", !1]],
  ["Watermelon Sorbet", ["#fc6c85", !1]],
  ["White", ["#ffffff", !1]],
  ["White and Blue", ["#d8deec", !1]],
  ["White and Red", ["#f87c7c", !1]],
  ["Yellow", ["#ffff00", !1]],
  ["Cool Blue", ["#4997D0", !1]],
  ["Sulphur Lime", ["#d6ff00", !1]],
["Dutch Blue", ["#3d73a4", !1]],
["Lemon and Grey", ["#fde910", !1]],
["Dark Brown", ["#654321", !1]],
["Powder Blue", ["#b0e0e6", !1]],
["Smokey Grey", ["#738276", !1]],
["Off-White and Blue", ["#1d5caa", !1]],
  ["Off-White and Brown", ["#8b4513", !1]],
  ["Off-White and Light Blue", ["#add8e6", !1]],
  ["Summer Sand", ["#E8D8B5", !1]],
  ["Matcha Green", ["#7CB342", !1]],
  ["Cosmic Blue", ["#2A4B7C", !1]],
  ["Olive Brown", ["#6B6A3C", !1]],
  ["Raw Denim", ["#2C3E50", !1]],
  ["Tortoise Brown", ["#6B4F3F", !1]],
  ["Black Forest", ["#1E2D24", !1]],
  ["Rust Rock", ["#8B3A2E", !1]],
  ["Sage", ["#9CAF88", !1]],
  ["Tobacco", ["#7A4A2E", !1]]
]);


function findHaxCode(key) {
  return colorMap.has(key) ? colorMap.get(key) : [key, !1];
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log("before render results 1");
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;
        // console.log(facets);
        if(facets)
        {
          // console.log("inside facets condition");
          facets.forEach((facet) => {
            if(facet.key === "product_Color")
            {
              // console.log("inside colors");
              facet.data.forEach((item) => {
                // console.log("inside loop");
                // console.log(item.key);
                let color = findHaxCode(item.key) || ["#e5e5e5", !1];
                // console.log(color);
                // console.log("inside loop 1");
                (item.isSwatch = !0),
                  (item.isURLSwatch = color[1]),
                  (item.isVisualSwatch = !0),
                  (item.swatchValue = color[0]),
                  (item.data = {
                    value: item.key,
                    swatch: {
                      type: "visual",
                      value: color[0],
                    },
                  });
              });
            }
          });
        }
        // console.log(payload);
      }
      // console.log("before render results 2");

      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
        setTimeout(syncAutocompleteWidth, 2);
        return data;
    });
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,

    function (data) {
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      // data.search.configs.displayAsDrawer = true;
      if(window.wizzyConfig.common.isOnCategoryPage)
      {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
          "#wizzy-shopify-collection-page-wrapper",
        ];
      }
      if (window.innerWidth > 935) {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
          {
            dom: ".search--popdown predictive-search .search__predictive__main .search__predictive__actions input",
            type: "search",
          },
        ];
      } else {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
          {
            dom: ".search-drawer predictive-search .search__predictive__main .search__predictive__actions input",
            type: "search",
          },
        ];
      }

      return data;
    },
    1
  );
  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,

  //   function (data) {
  //     data.filters.configs.keepOpenedInMobileAfterApply = true;
  //     data.search.configs.facets.leftFacets.mobileCollapsible = true;
  //     // data.search.configs.displayAsDrawer = true;
  //     if (window.matchMedia("(min-width: 935px)").matches) {
  //       window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
  //         {
  //           dom: ".search--popdown predictive-search .search__predictive__main .search__predictive__actions input",
  //           type: "search",
  //         },
  //       ];
  //     } else {
  //       window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
  //         {
  //           dom: ".search-drawer predictive-search .search__predictive__main .search__predictive__actions input",
  //           type: "search",
  //         },
  //       ];
  //     }

  //     return data;
  //   },
  //   1
  // );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,

    function (data) {
      let input1 = document.querySelector(
        ".search--popdown predictive-search .search__predictive__main .search__predictive__actions input"
      );
      if (input1) {
        input1.addEventListener("click", () => {
          // console.log("IN CLICK");
          changeCurrency();
        });
      }
      let input2 = document.querySelector(
        ".search-drawer predictive-search .search__predictive__main .search__predictive__actions input"
      );
      if (input2) {
        input2.addEventListener("click", () => {
          changeCurrency();
        });
      }
      changeCurrency();
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,

    function (data) {
      // console.log("Hello from lazy load");
      // data.filters.configs.keepOpenedInMobileAfterApply = true;
      // data.search.configs.facets.leftFacets.mobileCollapsible = true;
      // data.search.configs.displayAsDrawer = true;
      if(window.wizzyConfig.common.isOnCategoryPage)
      {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
          "#wizzy-shopify-collection-page-wrapper",
        ];
      }
      if (window.innerWidth > 935) {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
          {
            dom: ".search--popdown predictive-search .search__predictive__main .search__predictive__actions input",
            type: "search",
          },
        ];
      } else {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
          {
            dom: ".search-drawer predictive-search .search__predictive__main .search__predictive__actions input",
            type: "search",
          },
        ];
      }
      //data.common.lazyDOMConfig.contentDOMIdentifiers[0] = "#MainContent";
      // console.log("DATA === ", data);
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      document
        .querySelector("#init-wizzy-featured-view-button")
        .addEventListener("click", function () {
          if (typeof window.initFeaturedView !== "undefined") {
            window.initFeaturedView({
              dom: "wizzyFeaturedViewRoot",
              filters: window.location.href.includes(
                window.wizzyConfig.search.configs.general.searchEndpoint
              )
                ? JSON.stringify(
                    window.wizzyConfig.pageStore.searchedResponse.filters
                  )
                : window.wizzyConfig.pageStore.lastExecutedFilters,
              attributeIds: [
                "product_variant_ids",
                "product_sku",
                "product_value_tags_product_type",
                "product_filter_sub_categories_custom",
                "product_filter_color_custom",
                "product_filter_occasion_custom",
                "product_filter_fabric_custom",
                "product_filter_fabric_custom",
                "product_filter_work_custom",
                "product_style_no_custom",
                "product_Size",
                "product_Color",
              ],
              displayImageInSquare: true,
              // "9:16 Vertical Rectangle" === "1:1 Square" ? true : false,
              displayStoreName: true,
              displayDispalyAddToCartNumber: true,
              storeName: "VASA",
              currentCartCount: 0,
              displayAddToCart: true,
              displayViewMore: true,
              attributesToShowOnViewMore: [
                "product_custom_product_type",
                "product_Size",
                "product_Color",
                "product_filter_fabric_custom",
                "product_filter_work_custom",
                "product_style_no_custom",
              ],
            });
          }
        });
      return payload;
    });
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      products.forEach((product) => {
        i = 0;
        let img_array = [];
        product.images.forEach((image) => {
          if(i == 0)
          {
            img_array.push({
              src: image,
              index: i++,
              current: true,
            });
          }
          else
          {
            img_array.push({
              src: image,
              index: i++,
              current: false,
            });
          }
        });

        product.images = img_array;
        // if (product.swatches) {
        //   let swatch_array = [];
        //   let swatches = product.swatches[0];

        //   let colors;
        //   console.log("Swatches", swatches);
          // if (swatches) {
          //   colors = swatches.values;
          //   product.colorsLength = colors.length;
          //   product.hasColors = true;
          //   colors.forEach((color) => {
          //     // console.log("color", color);
          //     swatch_array.push({
          //       variationId: color.variationId,
          //       inStock: color.inStock,
          //       value: color.value,
          //       isSelected: color.isSelected,
          //       isSwatch: color.isSwatch,
          //       isVisualSwatch: color.isVisualSwatch,
          //       swatchValue: color.swatchValue,
          //       code: colorMap[color.value] || "#000000",
          //     });
          //   });
          //   product.swatches[0].values = swatch_array;
            
          // }

        // }
        
        if(product.swatches)
        {
          // var allowedKeys = ["product_Color", "product_Size"];
          // if (Array.isArray(product.swatches)) {
          //     var hasExtraKeys = product.swatches.some(function(swatch) {
          //         return swatch.key && !allowedKeys.includes(swatch.key);
          //     });

          //     if (hasExtraKeys) {
          //         product.quickView = true;
          //     }
          // }
          for (let i = product.swatches.length - 1; i >= 0; i--) {
            const swatch = product.swatches[i];
            if (swatch.key === "product_Size") {
              if(swatch.values.length > 1)
              {
                product.quickView = true;
              }
              product.swatches.splice(i, 1);
              product.quickSizes = swatch;
            }
          }
          for (let i = product.swatches.length - 1; i >= 0; i--) {
            const swatch = product.swatches[i];
            if(swatch.key )
            if (swatch.key === "product_Color") {

              if (swatch.values) {
                const colors = swatch.values;
                product.colorsLength = colors.length;
                product.hasColors = true;
                // console.log("colors", colors);
                const swatch_array = colors.filter(color => color.value !== "Multi-coloured").map(color => ({
                  // let color = findHaxCode(item.key) || ["#ffffff", !1];
                  
                  variationId: color.variationId,
                  inStock: color.inStock,
                  value: color.value,
                  isSelected: color.isSelected,
                  isSwatch: color.isSwatch,
                  isVisualSwatch: color.isVisualSwatch,
                  swatchValue: color.swatchValue,
                  code: findHaxCode(color.value)[0] || "#000000",
                }));

                swatch.values = swatch_array;
                product.swatch_colors = swatch_array;
              }
              // product.swatch_colors = swatch_array;
            }
          }
          if (product.quickAdd) {
            let sizes = product.quickSizes.values;
            sizes.forEach((size) => {
              if (size.inStock === true) {   // boolean check
                product.actions = true;
              }
            });
          }
        }
        let attributes = product.attributes;
        attributes.forEach((attr) => {
          if(attr.id === "product_handle")
          {
            product.productHandle = attr.values[0]?.value[0];
          }
        });
      });
      // let LeftNav_closeButton = document.querySelector(
      //   ".drawer__button.drawer__close"
      // );
      // if (LeftNav_closeButton) {
      //   console.log("FOund left nav");
      //   LeftNav_closeButton.click();
      // }
      return products;
    },
    1
  );
  let isOpen = true;
  let toggle = 1;
  let afterPDPopen = true;
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      // console.log("before search called");
      // localStorage.setItem("filter_opened", 1);
      document.body.classList.add('wizzy-search');
      if (window.innerWidth > 935) {
        let closeButton = document.querySelector(
          ".search--popdown predictive-search .search__predictive__main .search__predictive__close .search__predictive__close__inner"
        );

        if (closeButton) {
          closeButton.click();
        }
      } else {
        let closeButton = document.querySelector(
          ".drawer__button.drawer__close"
        );

        if (closeButton) {
          closeButton.click();
        }
      }
      // console.log("Its before search executed");
      // let searchWrapper = document.querySelector(
      //   ".wizzy-search-wrapper.has-left-facets .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-results "
      // );
      // let filterWrapper = document.querySelector(
      //   ".has-facets-in-drawer .wizzy-search-filters-left-wrapper"
      // );
      // let navBar = document.querySelector(".wizzy-search-results");
      // const rect = navBar.getBoundingClientRect();

      // if (filterWrapper) {
      //   filterWrapper.style.setProperty("display", "block", "important");
      //   // filterWrapper.style.top = `${rect.bottom}px`;
      //   console.log("Inside toggle 1", rect.bottom);
      //   filterWrapper.style.setProperty("left", "0", "important");
      // }
      // // if (filterWrapper) {
      // //   updateFilterPosition();
      // // }
      // if (searchWrapper)
      //   searchWrapper.style.setProperty("padding-left", "280px");
      // let textFilter = document.querySelector(".wizzy-filters-desktop-entry");
      // if (textFilter) textFilter.innerText = "Hide Filters";
      // updateFilterPosition();

      // isOpen = true;
      // afterPDPopen = true;
      // Trigger click

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      console.log("BEFORE_FILTERS_EXECUTED", data);
      // let filter_open = localStorage.getItem("filter_opened") || 1;
      // if(filter_open)
      // {
      //   OpenFilters();
      // }
      // else{
      //   CloseFilters();
      // }
      data.filters.swatch = [
        {"key": "product_Color"},
        {"key": "product_Size"}
      ]

      return data;
    }
  );
  function handleFilterClick(e) {
    e.preventDefault();
    let filter_open = localStorage.getItem("filter_opened") || 1;

    if (filter_open == 0) {
      OpenFilters();
      localStorage.setItem("filter_opened", 1);
    } else {
      CloseFilters();
      localStorage.setItem("filter_opened", 0);
    }
  }
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // $(document).on("click", ".facet-head-search", function () {
      //   $(this)
      //     .closest(".wizzy-facet-body")
      //     .find(".wizzy-show-more")         
      //     .trigger("click");                
      // });
       if(document.documentElement.clientWidth < 768  ){
        const wrapper = document.querySelector(".wizzy-search-summary-container");
        // console.log("Wrapper 0", wrapper);
        // console.log(window.innerWidth,document.documentElement.clientWidth);
        if (wrapper && wrapper.innerHTML.trim() === "") {
          const total = data?.data?.response?.payload?.total || 0;
          const query = data?.data?.response?.payload?.filters?.q || "";

          if(!window.wizzyConfig.common.isOnCategoryPage){
          wrapper.innerHTML = `
            <p class="wizzy-summary-head">${total} Results found for <strong>"${query}"</strong>:</p>
          `;
          }
          else if(window.wizzyConfig.common.isOnCategoryPage) {
          wrapper.innerHTML = `
            <p class="wizzy-summary-head">${total} Products</p>
          `;
          // console.log("wrapper", wrapper);
          }
          }
        }
      document.addEventListener("click", function (e) {
        if (e.target.closest(".facet-head-search")) {
          const facetBody = e.target.closest(".wizzy-facet-body");
          if (facetBody) {
            const showMore = facetBody.querySelector(".wizzy-show-more");
            if (showMore) showMore.click();
          }
        }
      });
      // console.log("view render called");
      const facetLists = document.querySelectorAll('.wizzy-facet-list');

      facetLists.forEach(function (ul) {
          const listItems = ul.querySelectorAll('li');
          const showMoreBtn = ul.parentElement.querySelector('.wizzy-show-more');

          if (listItems.length > 6) {
              // Hide all li after the 6th
              // for (let i = 6; i < listItems.length; i++) {
              //     listItems[i].style.display = 'none';
              // }
              ul.classList.add("show-less");

              // Show the show more button
              if (showMoreBtn) {
                  showMoreBtn.style.display = 'block';

                  showMoreBtn.addEventListener('click', function () {
                      ul.classList.remove("show-less");
                      // listItems.forEach(li => li.style.display = 'flex');
                      showMoreBtn.style.display = 'none';
                  });
              }
          }
      });
      setTimeout(() => {
        let input1 = document.querySelector(
          ".search--popdown predictive-search .search__predictive__main .search__predictive__actions input"
        );
        if (input1) {
          input1.addEventListener("click", () => {
            // console.log("IN CLICK");
            changeCurrency();
          });
        }
        let input2 = document.querySelector(
          ".search-drawer predictive-search .search__predictive__main .search__predictive__actions input"
        );
        if (input2) {
          input2.addEventListener("click", () => {
            changeCurrency();
          });
        }
        changeCurrency();
        // console.log(data);
        // console.log("Inside view rendered");
        // let LeftNav_closeButton = document.querySelector(
        //   ".drawer__button.drawer__close"
        // );
        // if (LeftNav_closeButton) {
        //   console.log("FOund left nav");
        //   LeftNav_closeButton.click();
        // }
        // let header_button = document.querySelector(".header__mobile__button");
        // header_button.addEventListener("click", function () {
        //   console.log("clicked header button");
        //   let LeftNav = document.querySelector(".drawer--visible");
        //   LeftNav.style.setProperty("display", "block", "important");
        // });

        let background_element = document.querySelectorAll(
          ".wizzy-search-wrapper .wizzy-search-filters-left .wizzy-facet-body .wizzy-facet-list .wizzy-facet-list-item.active .wizzy-facet-list-item-label .wizzy-facet-item-swatch.facet-visual-swatch"
        );
        // console.log(background_element.length);
        background_element.forEach((element) => {
          let rgbColor = window.getComputedStyle(element).backgroundColor;

          // Convert RGB to Hex
          let hexColor = rgbToHex(rgbColor);

          // Check against #ffffff
          if (hexColor.toLowerCase() === "#ffffff") {
            hexColor = "grey";
          }
          // console.log("hexColor", hexColor);
          let border_element = element.closest(
            ".wizzy-facet-item-swatch-wrapper"
          );
          if (border_element) {
            // console.log("Border Element found");
            border_element.style.setProperty(
              "border",
              `2px solid ${hexColor}`,
              "important"
            );
          }
        });
        // console.log("Console 1");
        // let color;
        // if (background_element) {
        //   color = background_element.style.background - color;
        // }

        // let border_elements = document.querySelectorAll(
        //   ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-facet-body .wizzy-facet-list .wizzy-facet-list-item.active .wizzy-facet-list-item-label .wizzy-facet-item-swatch-wrapper.facet-visual-swatch"
        // );
        let wizzyResults = document.querySelector(
          ".wizzy-search-results"
        );
        if(wizzyResults)
        {
          let tile_view;
          if(window.matchMedia("(min-width: 769px)").matches)
          {
            // console.log("In desktop");
            tile_view = localStorage.getItem("wizzy-tile-view") || 3;
            if(tile_view == 2)
            {
              wizzyResults.setAttribute("wizzy-data-grid", "2");
            }
            else if(tile_view == 3)
            {
              // console.log("in Desktop",wizzyResults);
              wizzyResults.setAttribute("wizzy-data-grid", "3");
            }
            else if(tile_view == 4)
            {
              wizzyResults.setAttribute("wizzy-data-grid", "4");
            }
          }
          else
          {
            tile_view = localStorage.getItem("wizzy-tile-view") || 2;
            if(tile_view == 2)
            {
              
              wizzyResults.setAttribute("wizzy-data-grid", "2");
              // console.log("in mobile", wizzyResults);
            }
            else if(tile_view == 1)
            {
              wizzyResults.setAttribute("wizzy-data-grid", "1");
            }
          }
        }


        // let searchResultsLists = document.querySelectorAll(
        //   ".wizzy-search-results-list"
        // );
        // if (window.innerWidth >= 480) {
        //   searchResultsLists.forEach((searchResultsList) => {
        //     if (!searchResultsList.hasAttribute("data-grid-large")) {
        //       searchResultsList.setAttribute("data-grid-large", "3");
        //     }

        //     if (!searchResultsList.hasAttribute("data-grid-small")) {
        //       searchResultsList.setAttribute("data-grid-small", "2");
        //     }
        //   });
        // } else {
        //   searchResultsLists.forEach((searchResultsList) => {
        //     if (!searchResultsList.hasAttribute("data-grid-large")) {
        //       searchResultsList.setAttribute("data-grid-large", "2");
        //     }

        //     if (!searchResultsList.hasAttribute("data-grid-small")) {
        //       searchResultsList.setAttribute("data-grid-small", "2");
        //     }
        //   });
        // }
        // console.log("Console 2");
        let grid_1_view = document.querySelector(".grid_1");
        if (grid_1_view) {
          grid_1_view.addEventListener("click", function () {
            // console.log("Grid 2 clicked.");
            localStorage.setItem("wizzy-tile-view", 1);
            wizzyResults.setAttribute("wizzy-data-grid", "1");
          });
        }

        let grid_2_view = document.querySelector(".grid_2");
        if (grid_2_view) {
          grid_2_view.addEventListener("click", function () {
            // console.log("Grid 2 clicked.");
            localStorage.setItem("wizzy-tile-view", 2)
            wizzyResults.setAttribute("wizzy-data-grid", "2");
          });
        }

        let grid_3_view = document.querySelector(".grid_3");
        if (grid_3_view) {
          grid_3_view.addEventListener("click", function () {
            localStorage.setItem("wizzy-tile-view", 3)
            wizzyResults.setAttribute("wizzy-data-grid", "3");
          });
        }

        let grid_4_view = document.querySelector(".grid_4");
        if (grid_4_view) {
          grid_4_view.addEventListener("click", function () {
            localStorage.setItem("wizzy-tile-view", 4)
            wizzyResults.setAttribute("wizzy-data-grid", "4");
          });
        }
        // console.log("Console 3");
        let filterButton = document.querySelector(
          ".wizzy-search-filters-drawer-button"
        );

        if (window.innerWidth > 768) {
          let filter_open = localStorage.getItem("filter_opened") || 1;
          if (filter_open == 1) {
            // console.log("called initial filter open condition");
            OpenFilters();
            
          }
          if(filterButton)
          {
            filterButton.removeEventListener("click", handleFilterClick);
            filterButton.addEventListener("click", handleFilterClick);
            // filterButton.addEventListener("click", function (e) {
            //   // console.log("Button is clicked");
            //   e.preventDefault();
            // let filter_open = localStorage.getItem("filter_opened") || 1;
            // if (filter_open == 0) {
            //     console.log("Inside open filter condition");
            //     // console.log("toggle 1");
            //     OpenFilters();
            //     localStorage.setItem("filter_opened", 1);
            //   } else {
            //     CloseFilters();
            //     localStorage.setItem("filter_opened", 0);
            //   }
            // });
          }
          // console.log("Console 4");
        }
        // console.log("Console 5");
        if (window.innerWidth > 768) {
          let firstElement = document.querySelector(
            ".wizzy-search-results-list"
          ); // Replace with your actual selector
          let secondElement = document.querySelector(
            ".has-facets-in-drawer .wizzy-search-filters-left-wrapper"
          ); // Replace with your actual selector
          let extraHeight = 80; // Adjust this value based on your requirement

          if (firstElement && secondElement) {
            let firstRect = firstElement.getBoundingClientRect();
            let secondRect = secondElement.getBoundingClientRect();

            let firstBottom = firstRect.bottom; // Bottom position of first element
            let secondBottom = secondRect.bottom; // Bottom position of second element

            // console.log("First Element Bottom:", firstBottom);
            // console.log("Second Element Bottom:", secondBottom);

            if (firstBottom < secondBottom) {
              let newHeight = secondBottom - firstRect.top + extraHeight;
              firstElement.style.height = `${newHeight}px`;
              // console.log(
              //   "Updated First Element Height:",
              //   firstElement.style.height
              // // );
            }
          }
        }
        if (window.innerWidth <= 768) {
          let filtersText = document.querySelector(
            ".wizzy-filters-desktop-entry"
          );
          if(filtersText)
            filtersText.innerText = "Filter";
          let sortText = document.querySelector(".wizzy-common-select-label");
          if(sortText)
            sortText.innerText = "Sort";

          // let closeButton = document.querySelector(".wizzy-filters-close-btn");
          // if (closeButton.style.display == "flex") {
          //   console.log("left is zero");
          //   let theme_header = document.querySelector(".theme__header");
          //   if (theme_header) {
          //     theme_header.style.display = "none";
          //   }
          // } else {
          //   let theme_header = document.querySelector(".theme__header");
          //   if (theme_header) {
          //     theme_header.style.display = "block";
          //   }
          // }
          // filterButton.addEventListener("click", function () {
          //   let theme_header = document.querySelector(".theme__header");
          //   if (theme_header) {
          //     theme_header.style.display = "none";
          //   }
          // });
        }
        document.addEventListener("click", function (event) {
          // Check if the clicked element has the class "swatch__label"
          if (event.target.classList.contains("swatch__label")) {
            // Get the parent product-grid-item (ensures it's the correct parent)
            let productItem = event.target.closest("product-grid-item");
            let id;
            if (productItem) {
              id = productItem.getAttribute("data-item-id"); // Get the product ID
              // console.log("Product Item ID:", id);
            }
            let element = document.querySelector(
              `.product-grid-item__content.is-slideshow[data-grid-item="${id}"]`
            );

            let variationId = event.target.getAttribute(
              "data-grid-item-variant"
            );
            // console.log("Variant ID:", variationId);
            if (element) {
              element.removeAttribute("hidden");
            }
            let addtocart = productItem.querySelector(
              ".shopify-product-form .input_class"
            );
            if(addtocart)
            {
              addtocart.setAttribute("value", variationId);
            }
          }
        });
        // console.log("Console 6");
        document.addEventListener("click", function (event) {
          // console.log(event.target.classList);
          // Check if the clicked element has the class "swatch__label"
          if (
            event.target.classList.contains("wizzy-add-to-cart")
          ) {
            // Get the parent product-grid-item (ensures it's the correct parent)
            let productItem = event.target.closest("product-grid-item");
            let header = document.querySelector(".header__wrapper");
            let theme_header = document.querySelector(".theme__header");
            if (theme_header) {
              theme_header.style.setProperty("z-index", 1);
            }

            if (header) header.style.setProperty("z-index", "1");
            // console.log("Header found");

            let popDown = productItem.querySelector(".product-add-popdown");
            popDown.classList.add("is-visible");
            let closePopDown = document.querySelector(".popdown__close__inner");
            closePopDown.addEventListener("click", function () {
              popDown.classList.remove("is-visible");
            });
            setTimeout(() => {
              let closePopDown = document.querySelector(
                ".popdown__close__inner"
              );
              closePopDown.addEventListener("click", function () {
                popDown.classList.remove("is-visible");
              });
              popDown.classList.remove("is-visible");
              if (header) header.style.removeProperty("z-index");
              theme_header.style.removeProperty("z-index");
            }, 3000);
          }
        });
        // console.log("Console 7");
        let closeButton = document.querySelector(
          ".wizzy-search-wrapper .drawer__button.drawer__close.drawer--visible"
        );
        if (closeButton) {
          closeButton.addEventListener("click", function () {
            // console.log("Clicked on close");
            let closeFilter = document.querySelector(
              ".wizzy-filters-close-btn"
            );
            closeFilter.click();
          });
        }
        // console.log("Console 8");
        let grid_colors = document.querySelectorAll(
          ".wizzy-grid-filters-box.facet-block-product_color_pattern_shopify .wizzy-facet-body .wizzy-facet-list .wizzy-facet-list-item"
        );
        if (grid_colors) {
          grid_colors.forEach((grid) => {
            let nearest_color = grid.querySelector(".wizzy-facet-item-swatch");
            // console.log("Console 9");
            if (nearest_color) {
              let bgColor =
                window.getComputedStyle(nearest_color).backgroundColor; // Get computed color

              if (bgColor && bgColor !== "rgba(0, 0, 0, 0)") {
                // Ensure it's not transparent
                grid.style.backgroundColor = bgColor;
              }
            }
          });
        }
        // console.log("Console 10");
        // let filterCounts = document.querySelectorAll(
        //   ".wizzy-facet-list-item-count"
        // );
        // filterCounts.forEach((filter) => {
        //   if (filter.innerText == "(1)") {
        //     filter.closest(".wizzy-facet-list-item").remove();
        //   }
        // });
      }, 50);
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      changeCurrency();

      // console.log("view render called");
      const facetLists = document.querySelectorAll('.wizzy-facet-list');

      facetLists.forEach(function (ul) {
          const listItems = ul.querySelectorAll('li');
          const showMoreBtn = ul.parentElement.querySelector('.wizzy-show-more');

          if (listItems.length > 6) {
              // Hide all li after the 6th
              // for (let i = 6; i < listItems.length; i++) {
              //     listItems[i].style.display = 'none';
              // }
              ul.classList.add("show-less");

              // Show the show more button
              if (showMoreBtn) {
                  showMoreBtn.style.display = 'block';

                  showMoreBtn.addEventListener('click', function () {
                      ul.classList.remove("show-less");
                      // listItems.forEach(li => li.style.display = 'flex');
                      showMoreBtn.style.display = 'none';
                  });
              }
          }
      });
      setTimeout(() => {
        let input1 = document.querySelector(
          ".search--popdown predictive-search .search__predictive__main .search__predictive__actions input"
        );
        if (input1) {
          input1.addEventListener("click", () => {
            // console.log("IN CLICK");
            changeCurrency();
          });
        }
        let input2 = document.querySelector(
          ".search-drawer predictive-search .search__predictive__main .search__predictive__actions input"
        );
        if (input2) {
          input2.addEventListener("click", () => {
            changeCurrency();
          });
        }
        changeCurrency();
        // console.log(data);
        // console.log("Inside view rendered");
        // let LeftNav_closeButton = document.querySelector(
        //   ".drawer__button.drawer__close"
        // );
        // if (LeftNav_closeButton) {
        //   console.log("FOund left nav");
        //   LeftNav_closeButton.click();
        // }
        // let header_button = document.querySelector(".header__mobile__button");
        // header_button.addEventListener("click", function () {
        //   console.log("clicked header button");
        //   let LeftNav = document.querySelector(".drawer--visible");
        //   LeftNav.style.setProperty("display", "block", "important");
        // });

        let background_element = document.querySelectorAll(
          ".wizzy-search-wrapper .wizzy-search-filters-left .wizzy-facet-body .wizzy-facet-list .wizzy-facet-list-item.active .wizzy-facet-list-item-label .wizzy-facet-item-swatch.facet-visual-swatch"
        );
        // console.log(background_element.length);
        background_element.forEach((element) => {
          let rgbColor = window.getComputedStyle(element).backgroundColor;

          // Convert RGB to Hex
          let hexColor = rgbToHex(rgbColor);

          // Check against #ffffff
          if (hexColor.toLowerCase() === "#ffffff") {
            hexColor = "grey";
          }
          // console.log("hexColor", hexColor);
          let border_element = element.closest(
            ".wizzy-facet-item-swatch-wrapper"
          );
          if (border_element) {
            // console.log("Border Element found");
            border_element.style.setProperty(
              "border",
              `2px solid ${hexColor}`,
              "important"
            );
          }
        });
        // console.log("Console 1");
        // let color;
        // if (background_element) {
        //   color = background_element.style.background - color;
        // }

        // let border_elements = document.querySelectorAll(
        //   ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-facet-body .wizzy-facet-list .wizzy-facet-list-item.active .wizzy-facet-list-item-label .wizzy-facet-item-swatch-wrapper.facet-visual-swatch"
        // );

        let searchResultsLists = document.querySelectorAll(
          ".wizzy-search-results-list"
        );
        if (window.innerWidth >= 480) {
          searchResultsLists.forEach((searchResultsList) => {
            if (!searchResultsList.hasAttribute("data-grid-large")) {
              searchResultsList.setAttribute("data-grid-large", "3");
            }

            if (!searchResultsList.hasAttribute("data-grid-small")) {
              searchResultsList.setAttribute("data-grid-small", "2");
            }
          });
        } else {
          searchResultsLists.forEach((searchResultsList) => {
            if (!searchResultsList.hasAttribute("data-grid-large")) {
              searchResultsList.setAttribute("data-grid-large", "2");
            }

            if (!searchResultsList.hasAttribute("data-grid-small")) {
              searchResultsList.setAttribute("data-grid-small", "2");
            }
          });
        }
        // console.log("Console 2");
        let grid_1_view = document.querySelector(".grid_1");
        if (grid_1_view) {
          grid_1_view.addEventListener("click", function () {
            // console.log("Grid 2 clicked.");
            searchResultsLists.forEach((searchResultsList) => {
              searchResultsList.setAttribute("data-grid-large", "1");
            });
          });
        }

        let grid_2_view = document.querySelector(".grid_2");
        if (grid_2_view) {
          grid_2_view.addEventListener("click", function () {
            // console.log("Grid 2 clicked.");
            searchResultsLists.forEach((searchResultsList) => {
              searchResultsList.setAttribute("data-grid-large", "2");
            });
          });
        }

        let grid_3_view = document.querySelector(".grid_3");
        if (grid_3_view) {
          grid_3_view.addEventListener("click", function () {
            searchResultsLists.forEach((searchResultsList) => {
              searchResultsList.setAttribute("data-grid-large", "3");
            });
          });
        }

        let grid_4_view = document.querySelector(".grid_4");
        if (grid_4_view) {
          grid_4_view.addEventListener("click", function () {
            searchResultsLists.forEach((searchResultsList) => {
              searchResultsList.setAttribute("data-grid-large", "4");
            });
          });
        }
        // console.log("Console 3");
        let filterButton = document.querySelector(
          ".wizzy-search-filters-drawer-button"
        );

        if (window.innerWidth > 768) {
          let filter_open = localStorage.getItem("filter_opened") || 1;
          if (filter_open == 1) {
            // console.log("called initial filter open condition");
            OpenFilters();
            
          }
          if(filterButton)
          {
            filterButton.removeEventListener("click", handleFilterClick);
            filterButton.addEventListener("click", handleFilterClick);
            // filterButton.addEventListener("click", function (e) {
            //   // console.log("Button is clicked");
            //   e.preventDefault();
            // let filter_open = localStorage.getItem("filter_opened") || 1;
            // if (filter_open == 0) {
            //     console.log("Inside open filter condition");
            //     // console.log("toggle 1");
            //     OpenFilters();
            //     localStorage.setItem("filter_opened", 1);
            //   } else {
            //     CloseFilters();
            //     localStorage.setItem("filter_opened", 0);
            //   }
            // });
          }
          // console.log("Console 4");
        }
        // console.log("Console 5");
        if (window.innerWidth > 768) {
          let firstElement = document.querySelector(
            ".wizzy-search-results-list"
          ); // Replace with your actual selector
          let secondElement = document.querySelector(
            ".has-facets-in-drawer .wizzy-search-filters-left-wrapper"
          ); // Replace with your actual selector
          let extraHeight = 80; // Adjust this value based on your requirement

          if (firstElement && secondElement) {
            let firstRect = firstElement.getBoundingClientRect();
            let secondRect = secondElement.getBoundingClientRect();

            let firstBottom = firstRect.bottom; // Bottom position of first element
            let secondBottom = secondRect.bottom; // Bottom position of second element

            // console.log("First Element Bottom:", firstBottom);
            // console.log("Second Element Bottom:", secondBottom);

            if (firstBottom < secondBottom) {
              let newHeight = secondBottom - firstRect.top + extraHeight;
              firstElement.style.height = `${newHeight}px`;
              // console.log(
              //   "Updated First Element Height:",
              //   firstElement.style.height
              // // );
            }
          }
        }
        if (window.innerWidth <= 768) {
          let filtersText = document.querySelector(
            ".wizzy-filters-desktop-entry"
          );
          if(filtersText)
            filtersText.innerText = "Filter";
          let sortText = document.querySelector(".wizzy-common-select-label");
          if(sortText)
            sortText.innerText = "Sort";

          // let closeButton = document.querySelector(".wizzy-filters-close-btn");
          // if (closeButton.style.display == "flex") {
          //   console.log("left is zero");
          //   let theme_header = document.querySelector(".theme__header");
          //   if (theme_header) {
          //     theme_header.style.display = "none";
          //   }
          // } else {
          //   let theme_header = document.querySelector(".theme__header");
          //   if (theme_header) {
          //     theme_header.style.display = "block";
          //   }
          // }
          // filterButton.addEventListener("click", function () {
          //   let theme_header = document.querySelector(".theme__header");
          //   if (theme_header) {
          //     theme_header.style.display = "none";
          //   }
          // });
        }
        document.addEventListener("click", function (event) {
          // Check if the clicked element has the class "swatch__label"
          if (event.target.classList.contains("swatch__label")) {
            // Get the parent product-grid-item (ensures it's the correct parent)
            let productItem = event.target.closest("product-grid-item");
            let id;
            if (productItem) {
              id = productItem.getAttribute("data-item-id"); // Get the product ID
              // console.log("Product Item ID:", id);
            }
            let element = document.querySelector(
              `.product-grid-item__content.is-slideshow[data-grid-item="${id}"]`
            );

            let variationId = event.target.getAttribute(
              "data-grid-item-variant"
            );
            // console.log("Variant ID:", variationId);
            if (element) {
              element.removeAttribute("hidden");
            }
            let addtocart = productItem.querySelector(
              ".shopify-product-form .input_class"
            );
            addtocart.setAttribute("value", variationId);
          }
        });
        // console.log("Console 6");
        document.addEventListener("click", function (event) {
          // console.log(event.target.classList);
          // Check if the clicked element has the class "swatch__label"
          if (
            event.target.classList.contains("stain-button-canvas") ||
            event.target.classList.contains("btn-state-ready") ||
            event.target.classList.contains("text-button-contrast") ||
            event.target.classList.contains("shopify-product-form") ||
            event.target.classList.contains("icon-set-classic-cart") ||
            (event.target.classList.contains("hidden") &&
              event.target.classList.contains("md:block"))
          ) {
            // Get the parent product-grid-item (ensures it's the correct parent)
            let productItem = event.target.closest("product-grid-item");
            let header = document.querySelector(".header__wrapper");
            let theme_header = document.querySelector(".theme__header");
            if (theme_header) {
              theme_header.style.setProperty("z-index", 1);
            }

            if (header) header.style.setProperty("z-index", "1");
            // console.log("Header found");

            let popDown = productItem.querySelector(".product-add-popdown");
            popDown.classList.add("is-visible");
            let closePopDown = document.querySelector(".popdown__close__inner");
            closePopDown.addEventListener("click", function () {
              popDown.classList.remove("is-visible");
            });
            setTimeout(() => {
              let closePopDown = document.querySelector(
                ".popdown__close__inner"
              );
              closePopDown.addEventListener("click", function () {
                popDown.classList.remove("is-visible");
              });
              popDown.classList.remove("is-visible");
              if (header) header.style.removeProperty("z-index");
              theme_header.style.removeProperty("z-index");
            }, 3000);
          }
        });
        // console.log("Console 7");
        let closeButton = document.querySelector(
          ".wizzy-search-wrapper .drawer__button.drawer__close.drawer--visible"
        );
        if (closeButton) {
          closeButton.addEventListener("click", function () {
            // console.log("Clicked on close");
            let closeFilter = document.querySelector(
              ".wizzy-filters-close-btn"
            );
            closeFilter.click();
          });
        }
        // console.log("Console 8");
        let grid_colors = document.querySelectorAll(
          ".wizzy-grid-filters-box.facet-block-product_color_pattern_shopify .wizzy-facet-body .wizzy-facet-list .wizzy-facet-list-item"
        );
        if (grid_colors) {
          grid_colors.forEach((grid) => {
            let nearest_color = grid.querySelector(".wizzy-facet-item-swatch");
            // console.log("Console 9");
            if (nearest_color) {
              let bgColor =
                window.getComputedStyle(nearest_color).backgroundColor; // Get computed color

              if (bgColor && bgColor !== "rgba(0, 0, 0, 0)") {
                // Ensure it's not transparent
                grid.style.backgroundColor = bgColor;
              }
            }
          });
        }
        // console.log("Console 10");
        // let filterCounts = document.querySelectorAll(
        //   ".wizzy-facet-list-item-count"
        // );
        // filterCounts.forEach((filter) => {
        //   if (filter.innerText == "(1)") {
        //     filter.closest(".wizzy-facet-list-item").remove();
        //   }
        // });
      }, 50);
      return data;
    }
  );
  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
  //   function (data) {
  //     console.log("BEFORE_RESULTS_RENDERED", data);
  //     const facets = data.response.payload.facets;
  //     facets.filter((facet) => (facet.data.isArray && facet.data.length != 1)
  //     return data;
  //   }
  // );
  const targetNode = document.querySelector(".wizzy-body-end-wrapper");
  function updateBodyClass() {
      const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
      autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
  }
  const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
  }
    , callback = function(mutationsList, observer2) {
      for (const mutation of mutationsList) {
          updateBodyClass();
          break
      }
  }
    , observer = new MutationObserver(callback);
  targetNode && (observer.observe(targetNode, config),
  updateBodyClass());
};
///////////////////////////////////////////////////////////////////////////////////////////////////////////
let navLink = document.querySelector(
  ".header__desktop__buttons--icons .header__desktop__button .navlink .icon-set-mod-search"
);
navLink.addEventListener("click", function () {
  // console.log("Clicked on navlink");
  let search_field = document.querySelector(
    ".search--popdown predictive-search .search__predictive__main .search__predictive__actions input"
  );
  if (search_field) {
    setTimeout(() => {
      search_field.click();
    }, 600);
  }
});
if (window.innerWidth > 768)
  // window.addEventListener("resize", updateFilterPosition);

// window.onWizzyLoaded.push(wizzyEvents);
if (window.innerWidth > 768) {
  window.addEventListener("scroll", function () {
    requestAnimationFrame(() => {
      let fixedElement = document.querySelector(
        ".wizzy-search-filters-left-wrapper"
      );
      let scrollAmount = window.scrollY;
      if (fixedElement) {
        // fixedElement.style.transform = `translateY(${-scrollAmount}px)`;
      }
    });
  });
}

/////////////////////////////////////////////////////////////////////
